import React, { useState, useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import "../../styles/SeparateInvoice.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import backdateddays_icon from "../../assets/svg/backdateddays_icon.svg"
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from "../../axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import SapCsvSafeInput from '../../CommonRemarksRestriction/SapCsvSafeInput';

const SeparateInvoice = ({
    isOpen,
    onClose,
    separateChargesData,
    loading = false,
    backdatedDays = 0,
    projectId,
    allCategories = [],
    selectedChargeIds = {}
}) => {

    const [globalBackdatedDate, setGlobalBackdatedDate] = useState("");
    const [lineItems, setLineItems] = useState([]);
    const [saveMode, setSaveMode] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const globalDatePickerRef = useRef();
    const lineItemDatePickerRefs = useRef({});
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [globalBillingNature, setGlobalBillingNature] = useState("");
    const [globalSupplyPeriod, setGlobalSupplyPeriod] = useState(null);
    const getMinBackdatedDate = (currentDate, days) => {
        const minDate = new Date(currentDate);
        minDate.setDate(minDate.getDate() - (days || 0));
        return minDate;
    };

    useEffect(() => {
        if (isOpen && separateChargesData) {
            console.log("===== SEPARATE INVOICE INIT DEBUG =====");
            console.log("isOpen:", isOpen);
            console.log("Raw separateChargesData:", JSON.parse(JSON.stringify(separateChargesData)));

            const flattenedItems = [];
            separateChargesData.forEach(job => {
                console.log("Job Loop:", job);

                job.details.forEach(detail => {
                    console.log("Detail Loop:", detail);

                    const item = {
                        id: `${job.job_no}_${detail.charge_id}_${Math.random()}`,
                        job_no: job.job_no,
                        charge_code: detail.charge_code,
                        description: detail.description,
                        ff_plant_id: job.ff_plant_id,
                        job_type_division: detail.job_type_division?.toLowerCase(),
                        po_wo_number: detail.sales_po_wo_number,
                        po_wo_date: detail.sales_po_wo_date,
                        quantity: detail.sales_unit_of_quantity,
                        accrual: detail.sales_accrual,
                        contract_value: detail.sales_contract_value,
                        rate: detail.sales_unit_of_rate,
                        net_total: detail.sales_net_total,
                        remarks: detail.sales_remarks || "",
                        backdated_date: "",
                        project_id: detail.project_id,
                        job_id: detail.job_id,
                        charge_id: detail.charge_id,
                        job_type_id: detail.job_type_id,
                        job_line_id: detail.jobLineId || detail.job_sales_line_id || detail.job_line_id_key,
                        backdated_days: backdatedDays,
                        sales_header_remarks: detail.sales_remarks || "",
                        billing_nature: "",
                        supply_period: job.supply_period
                            ? new Date(`${job.supply_period.split("-")[0]} 1, ${job.supply_period.split("-")[1]}`)
                            : null,
                        uploadedFiles: []
                    };

                    console.log("Flattened Item Being Added:", item);
                    flattenedItems.push(item);
                });
            });

            console.log("Final Flattened Items:", JSON.parse(JSON.stringify(flattenedItems)));
            console.log("========================================");

            setLineItems(flattenedItems);
            setGlobalBackdatedDate("");
            setGlobalBillingNature("");
            setGlobalSupplyPeriod(null);
            setSaveMode(true);
        }
    }, [isOpen, separateChargesData, backdatedDays]);


    useEffect(() => {
        if (globalBackdatedDate) {
            setLineItems(prev =>
                prev.map(item => ({
                    ...item,
                    backdated_date: globalBackdatedDate
                }))
            );
        }
    }, [globalBackdatedDate]);

    useEffect(() => {
        setLineItems(prev =>
            prev.map(item => ({
                ...item,
                billing_nature: globalBillingNature || ""
            }))
        );
    }, [globalBillingNature]);

    useEffect(() => {
        if (globalSupplyPeriod) {
            setLineItems(prev =>
                prev.map(item => ({
                    ...item,
                    supply_period: globalSupplyPeriod
                }))
            );
        }
    }, [globalSupplyPeriod]);


    const handleLineItemChange = (id, field, value) => {
        setLineItems(prev => prev.map(item =>
            item.id === id ? { ...item, [field]: value } : item
        ));
        setErrors(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: undefined
            }
        }));
    };

    // const validateForSubmit = () => {
    //     let errObj = {};

    //     lineItems.forEach((item, index) => {
    //         let itemErrors = {};

    //         if (!item.sales_header_remarks?.trim()) {
    //             itemErrors.sales_header_remarks = "Remarks to Customer is required";
    //         }
    //         if (!item.billing_nature?.trim()) {
    //             itemErrors.billing_nature = "Billing Nature is required";
    //         }
    //         if (!item.supply_period) {
    //             itemErrors.supply_period = "Supply Period is required";
    //         }

    //         if (Object.keys(itemErrors).length > 0) {
    //             errObj[item.id] = itemErrors;
    //         }
    //     });

    //     return errObj;
    // };

    const getUploadedFilesForJobLine = (jobLineId) => {
        if (!jobLineId || !allCategories) return [];

        for (const category of allCategories) {
            for (const row of category.rows) {
                if (row.jobLineId === jobLineId || row.job_sales_line_id === jobLineId) {
                    return row.uploadedFiles || [];
                }
            }
        }
        return [];
    };

    const buildPayload = (actionType) => {
        const formatSupplyPeriod = (date) => {
            if (!date) return null;
            const d = new Date(date);
            return (
                  d.toLocaleString("en-US", { month: "short" }) +
                "-" +
                d.getFullYear()
            );
        };

        const jobsMap = {};

        lineItems.forEach((item) => {
            if (!jobsMap[item.job_id]) {
                jobsMap[item.job_id] = {
                    id: item.job_id,
                    jobnumber: item.job_no,
                    project_id: item.project_id || projectId,
                    job_type_id: item.job_type_id,
                    job_created_date: new Date().toISOString().split("T")[0],
                    ff_plant_id: item.ff_plant_id,
                    job_line: [],
                };
            }

            jobsMap[item.job_id].job_line.push({
                project_id: item.project_id || projectId,
                job_type_id: item.job_type_id,
                job_line_id: item.job_line_id,
                charge_id: item.charge_id,
                description_of_charges: item.description,
                po_wo_number: item.po_wo_number,
                po_wo_date: item.po_wo_date,
                unit_of_quantity: parseFloat(item.quantity) || 0,
                accrual: item.accrual,
                contract_value: item.contract_value,
                remarks: item.remarks || "",
                unit_of_rate: parseFloat(item.rate) || 0,
                net_total: parseFloat(item.net_total) || 0,
            });
        });

        const jobs = Object.values(jobsMap);

        const salesHeaderRemarksObj = {};
        const billingNatureObj = {};
        const supplyPeriodObj = {};
        const backdatedDateObj = {};

        lineItems.forEach((item) => {
            const id = item.job_line_id;

            salesHeaderRemarksObj[id] = item.sales_header_remarks || "";
            billingNatureObj[id] = item.billing_nature || "";
            supplyPeriodObj[id] = item.supply_period
                ? formatSupplyPeriod(item.supply_period)
                : "";
            backdatedDateObj[id] = item.backdated_date || null;
        });

        const payload = {
            invoice_mode: "separate",
            generate_invoice: "1",
            invoice_target: "sales",
            actions: [actionType],
            jobs,
            sales_header_remarks: salesHeaderRemarksObj || "",
            billing_nature: billingNatureObj || "",
            supply_period: supplyPeriodObj || "",
            backdated_date: backdatedDateObj,
            division_type: lineItems?.[0]?.job_type_division?.toLowerCase() || ""
        };

        console.log("======= BUILD PAYLOAD DEBUG =======");
        console.log(payload);
        console.log("==================================");

        return payload;
    };


    const handleSeparateSubmit = async (actionType) => {
        if (actionType === "save" && isSaving) return;
        if (actionType === "submit" && isSubmitting) return;

        actionType === "save"
            ? setIsSaving(true)
            : setIsSubmitting(true);

        try {
            const payload = buildPayload(actionType);

            const formData = new FormData();
            formData.append("data", JSON.stringify(payload));

            lineItems.forEach(item => {
                const uploadedFiles = getUploadedFilesForJobLine(item.job_line_id);

                if (uploadedFiles.length > 0) {
                    uploadedFiles.forEach((file) => {
                        const key = item.job_line_id.toString();
                        formData.append(`attachments[${key}][]`, file);
                    });
                }
            });

            const response = await axiosInstance.post("/invoice/save", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.status === 200 && response.data.success === true) {
                toast.success(
                    `Sales Invoice ${actionType === "save" ? "saved" : "submitted"} successfully!`
                );
                sessionStorage.removeItem("mergedChargesData");
                sessionStorage.removeItem("separateChargesData");
                onClose();
                navigate("/salesInvoice");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error submitting separate invoice:", error);
            toast.error(
                "Error while submitting: " + (error.response?.data?.message || error.message)
            );
        } finally {
            actionType === "save"
                ? setIsSaving(false)
                : setIsSubmitting(false);
        }
    };


    const handleSave = () => {
        if (lineItems.length === 0) {
            alert("No line items to save");
            return;
        }
        setSaveMode(true);
        handleSeparateSubmit("save");
    };

    const handleSubmit = () => {
        // const validationErrors = validateForSubmit();

        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        // setErrors({});
        setSaveMode(false);
        handleSeparateSubmit("submit");
    };

    const formatDate = (d) => {
        const dt = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
        return dt.toISOString().split('T')[0];
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="separate-invoice-popup-overlay">
                <div className="separate-invoice-popup-container">
                    <div className="separate-invoice-popup-header">
                        <h2>Separate Invoice</h2>

                        <div className="separate-invoice-header-right">
                            {/* <p>Backdated Date for all :</p>

                            <div className="global-backdated-wrapper">

                                <DatePicker
                                    ref={globalDatePickerRef}
                                    selected={globalBackdatedDate ? new Date(globalBackdatedDate) : null}
                                    onChange={(date) => {
                                        const formatted = date ? formatDate(date) : "";
                                        setGlobalBackdatedDate(formatted);

                                        setLineItems(prev =>
                                            prev.map(item => ({
                                                ...item,
                                                backdated_date: formatted
                                            }))
                                        );
                                    }}
                                    isClearable={!!globalBackdatedDate}
                                    dateFormat="yyyy-MM-dd"
                                    className="custom-datepicker-input global-backdated-input"
                                    placeholderText="Select a backdated date"
                                    minDate={getMinBackdatedDate(new Date(), backdatedDays)}
                                    maxDate={new Date()}
                                />

                                {!globalBackdatedDate && (
                                    <img
                                        src={backdateddays_icon}
                                        className="global-backdated-icon"
                                        alt="backdated"
                                    />
                                )}

                            </div>

                            <div className="separate-backdated-date-divider"></div> */}

                            <button
                                className="separate-invoice-btn-save"
                                onClick={handleSave}
                                disabled={isSaving}
                            >
                                {isSaving ? "Saving..." : "Save"}
                            </button>

                            <button
                                className="separate-invoice-btn-submit"
                                onClick={handleSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                            <div
                                className="merged-close-btn"
                                onClick={onClose}
                            >
                                <X size={16} />
                            </div>
                        </div>
                    </div>

                    <div className="separate-invoice-scroll-area">
                        <div className="global-header">
                            <h4 className="global-title">Global Invoice Fields</h4>
                            <div className="global-subtitle">
                                <span className="info-icon">!</span>
                                <span>Values entered here will be applied to all invoice line items</span>
                            </div>
                        </div>

                        <div className="global-wrapper-all">
                            <div className="global-field" style={{ position: "relative" }}>
                                <label className="global-label">Billing Nature for all</label>
                                <SapCsvSafeInput
                                    className="global-input"
                                    placeholder="Enter Billing Nature"
                                    value={globalBillingNature}
                                    onChange={setGlobalBillingNature}
                                    maxLength={18}
                                    style={{ margin: "0px", paddingRight: "30px" }}
                                />
                                {globalBillingNature && (
                                    <span
                                        onClick={() => setGlobalBillingNature("")}
                                        title="Clear"
                                        style={{
                                            position: "absolute",
                                            right: "8px",
                                            top: "70%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "50%",
                                            backgroundColor: "#216ba5",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 0 0 1px #ddd",
                                        }}
                                    >
                                        <X size={10} color="#fff" />
                                    </span>
                                )}
                            </div>

                            <div className="global-field">
                                <label className="global-label">Supply Period for all</label>
                                <DatePicker
                                    selected={globalSupplyPeriod}
                                    onChange={(date) => {
                                        setGlobalSupplyPeriod(date);

                                        setLineItems(prev =>
                                            prev.map(item => ({
                                                ...item,
                                                supply_period: date
                                            }))
                                        );
                                    }}
                                    dateFormat="MMM-yyyy"
                                    showMonthYearPicker
                                    className="global-supplyperiod-input"
                                    placeholderText="Select month & year"
                                    isClearable
                                    disabled
                                />

                            </div>

                            <div className="global-field">
                                <label className="global-label">Backdated Date for all :</label>

                                <div className="global-backdated-wrapper">
                                    <DatePicker
                                        ref={globalDatePickerRef}
                                        selected={globalBackdatedDate ? new Date(globalBackdatedDate) : null}
                                        onChange={(date) => {
                                            const formatted = date ? formatDate(date) : "";
                                            setGlobalBackdatedDate(formatted);

                                            setLineItems(prev =>
                                                prev.map(item => ({
                                                    ...item,
                                                    backdated_date: formatted
                                                }))
                                            );
                                        }}
                                        isClearable={!!globalBackdatedDate}
                                        dateFormat="yyyy-MM-dd"
                                        className="global-backdated-input"
                                        placeholderText="Select a backdated date"
                                        minDate={getMinBackdatedDate(new Date(), backdatedDays)}
                                        maxDate={new Date()}
                                    />

                                    {!globalBackdatedDate && (
                                        <img
                                            src={backdateddays_icon}
                                            className="global-backdated-icon"
                                            alt="backdated"
                                        />
                                    )}
                                </div>
                            </div>

                        </div>
                        {lineItems.map((item, index) => (
                            <div key={item.id} className='separate-invoice-main-card'>
                                <div className="separate-invoice-card-section">
                                    <div className="separate-invoice-card">
                                        <div className="separate-left-block">
                                            <p className="separate-title">{item.description}</p>
                                            <p className="separate-code">Charge code : <span>{item.charge_code}</span></p>
                                        </div>

                                        <div className="separate-divider"></div>

                                        <div className="separate-info-box qty">
                                            <p className="label">Quantity</p>
                                            <p className="value">{parseFloat(item.quantity).toFixed(2)}</p>
                                        </div>

                                        <div className="separate-info-box rate">
                                            <p className="label">Rate</p>
                                            <p className="value">₹ {parseFloat(item.rate).toLocaleString('en-IN')}</p>
                                        </div>

                                        <div className="separate-info-box net-total">
                                            <p className="label">Net Total</p>
                                            <p className="value net-total-value"
                                                title={`₹ ${parseFloat(item.net_total).toLocaleString('en-IN')}`}>₹ {parseFloat(item.net_total).toLocaleString('en-IN')}</p>
                                        </div>

                                        <div className="separate-info-box full-width">
                                            <p className="label">Remarks</p>
                                            <p className="value" title={item.remarks}>
                                                {item.remarks.length > 28 ? item.remarks.slice(0, 28) + "..." : item.remarks}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="separate-invoice-card-section second">
                                    <div className="separate-invoice-grid-2">
                                        <div className="separate-input-wrapper">
                                            <label className="separate-input-label">
                                                Remarks to Customer
                                            </label>

                                            <div className="input-with-counter">
                                                <SapCsvSafeInput
                                                    className="separate-invoice-input-box"
                                                    placeholder="Remarks to Customer"
                                                    value={item.sales_header_remarks || ""}
                                                    onChange={(val) =>
                                                        handleLineItemChange(item.id, "sales_header_remarks", val)
                                                    }
                                                    maxLength={255}
                                                    required={!saveMode}
                                                />

                                                <span className="separate-input-counter">
                                                    {(item.sales_header_remarks?.length || 0)}/255
                                                </span>
                                            </div>

                                            {errors[item.id]?.sales_header_remarks && (
                                                <p className="separate-input-error">{errors[item.id].sales_header_remarks}</p>
                                            )}
                                        </div>


                                        <div className="separate-input-wrapper">
                                            <label style={{ color: '#212129', fontWeight: 600 }}>
                                                Billing Nature
                                            </label>

                                            <div className="input-with-counter">
                                                <SapCsvSafeInput
                                                    className="separate-invoice-input-box"
                                                    placeholder="Enter billing nature"
                                                    value={item.billing_nature || ""}
                                                    onChange={(val) =>
                                                        handleLineItemChange(item.id, "billing_nature", val)
                                                    }
                                                    maxLength={18}
                                                    required={!saveMode}
                                                    style={{ paddingRight: "40px" }}
                                                />

                                                <span className="separate-input-counter"
                                                    style={{
                                                        position: "absolute",
                                                        right: "10px",
                                                        bottom: "12px",
                                                        pointerEvents: "none",
                                                        fontSize: "11px",
                                                        color: "#777",
                                                    }}
                                                >
                                                    {(item.billing_nature?.length || 0)}/18
                                                </span>
                                            </div>
                                            {errors[item.id]?.billing_nature && (
                                                <p className="separate-input-error">
                                                    {errors[item.id].billing_nature}
                                                </p>
                                            )}
                                        </div>


                                        <div>
                                            <label style={{ color: '#212129', fontWeight: 600 }}>
                                                Supply Period
                                            </label>
                                            <div className="supply-period-picker">
                                                <DatePicker
                                                    selected={item.supply_period}
                                                    onChange={(date) =>
                                                        handleLineItemChange(item.id, "supply_period", date)
                                                    }
                                                    dateFormat="MMM-yyyy"
                                                    showMonthYearPicker
                                                    className="separate-invoice-input-box"
                                                    placeholderText="Select month & year"
                                                    required={!saveMode}
                                                    disabled
                                                />
                                            </div>
                                            {errors[item.id]?.supply_period && (
                                                <p style={{ color: "red", fontSize: "12px", marginTop: "3px" }}>
                                                    {errors[item.id].supply_period}
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label style={{ color: '#212129', fontWeight: 600 }}>
                                                Backdated Date
                                            </label>
                                            <div className="supply-period-picker">
                                                <DatePicker
                                                    ref={el => lineItemDatePickerRefs.current[item.id] = el}
                                                    selected={item.backdated_date ? new Date(item.backdated_date) : null}
                                                    onChange={(date) => {
                                                        handleLineItemChange(
                                                            item.id,
                                                            "backdated_date",
                                                            date ? formatDate(date) : ""
                                                        );
                                                    }}
                                                    dateFormat="yyyy-MM-dd"
                                                    className="separate-invoice-input-box backdateddays-input"
                                                    placeholderText="Select a backdated date"
                                                    minDate={getMinBackdatedDate(new Date(), item.backdated_days || 0)}
                                                    maxDate={new Date()}
                                                />

                                                <img src={backdateddays_icon} className="backdateddays-icon" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default SeparateInvoice;